import { urlConfig } from '@config/url.config';
import AbstractAPI from './Abstract.api';

enum userTypes {
    superuser = 'superuser',
    regular = 'regular',
    subuser = 'subuser',
}

export type userType = `${userTypes}`;

export interface IUserSettings {
    timezone: number;
    default_group: string;
}

interface ILoginRes {
    devices: [];
    type: userType;
    token: string;
}

interface IGetUserSettings {
    settings: IUserSettings;
}

export class UserAPI extends AbstractAPI {
    async login(login: string, password: string) {
        const pathname = 'user/login';
        const method = 'POST';
        const body = {
            login,
            password,
        };
        try {
            return await this._request<ILoginRes>(pathname, method, body);
        } catch (e) {
            throw new Error(e);
        }
    }
    async loginOldAccount(email: string, password: string, token: string) {
        const pathname = 'user/add_old_account';
        const method = 'POST';
        const body = {
            token,
            email,
            password,
        };
        try {
            return await this._requestOldLogin<ILoginRes>(pathname, method, body);
        } catch (e) {
            throw new Error(e);
        }
    }
    async logout(email: string, token: string) {
        const pathname = 'user/logout';
        const method = 'POST';
        const body = {
            email,
            token,
        };
        try {
            return await this._request(pathname, method, body);
        } catch (e) {
            throw new Error(e);
        }
    }
    async register(email: string, password: string) {
        const pathname = 'user/register';
        const method = 'POST';
        const body = {
            email,
            password,
        };
        try {
            return await this._request(pathname, method, body);
        } catch (e) {
            throw new Error(e);
        }
    }
    async confirm(email: string, code: string) {
        const pathname = 'user/register_confirm';
        const method = 'POST';
        const body = {
            email,
            code,
        };
        try {
            return await this._request(pathname, method, body);
        } catch (e) {
            throw new Error(e);
        }
    }
    async requestConfirm(email: string) {
        const pathname = 'user/send_again';
        const method = 'POST';
        const body = {
            email,
        };
        try {
            return await this._request(pathname, method, body);
        } catch (e) {
            throw new Error(e);
        }
    }
    async passwordRecovery(email: string) {
        const pathname = 'user/reset_password';
        const method = 'POST';
        const body = {
            email,
        };
        try {
            return await this._request(pathname, method, body);
        } catch (e) {
            throw new Error(e);
        }
    }
    async confirmPasswordRecovery(
        email: string,
        password: string,
        code: string,
    ) {
        const pathname = 'user/reset_password_confirm';
        const method = 'POST';
        const body = {
            email,
            password,
            code,
        };
        try {
            return await this._request(pathname, method, body);
        } catch (e) {
            throw new Error(e);
        }
    }
    async getSettings(token: string) {
        const pathname = 'user/get_settings';
        const method = 'POST';
        const body = {
            token,
        };
        try {
            return await this._request<IGetUserSettings>(
                pathname,
                method,
                body,
            );
        } catch (e) {
            throw new Error(e);
        }
    }
    async changeSettings(token: string, settings: Partial<IUserSettings>) {
        const pathname = 'user/change_settings';
        const method = 'POST';
        const body = {
            token,
            settings,
        };
        try {
            return await this._request(pathname, method, body);
        } catch (e) {
            throw new Error(e);
        }
    }
}

export const userAPI = new UserAPI(urlConfig);
